import { createDraftSafeSelector, createSlice } from "@reduxjs/toolkit";
import {
  getReservations,
  createReservationThunk,
  editReservation,
  removeReservation,
  editReservationStatus
} from "./thunks";
import { formatReservationWithDestinations } from "../../util/util";

const initialState = {
  reservations: [],
  error: null,
  status: "idle",
  lastFetched: null,
};

export const reservationSlice = createSlice({
  name: "reservations",
  initialState,
  reducers: {
    addReservation: (state, action) => {
      state.reservations.push(action.payload);
    },
    resetReservationStatus: (state) => { state.status = 'idle'; state.lastFetched = null; },
  },
  extraReducers: (builder) => {
    builder.addCase(getReservations.pending, (state, action) => {
      state.status = "loading";
    });

    builder.addCase(getReservations.fulfilled, (state, action) => {
      const newReservations = (action.payload || []).map((e) =>
        formatReservationWithDestinations(e)
      );
      state.reservations = newReservations;
      state.status = "successful";
      state.lastFetched = Date.now();
    });

    builder.addCase(getReservations.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.error;
    });

    builder.addCase(removeReservation.fulfilled, (state, action) => {
      state.status = "successful";
      state.reservations = state.reservations.filter(e => e.id !== action.payload)
    });

    builder.addCase(editReservation.fulfilled, (state, action) => {
      const payload = action.payload;
      const { cotizationDetail, hotelPrices, aerolinePrices } = payload;
      //Actualizacion de detalles de la reservation
      state.reservations = state.reservations.map((e) => {
        if (e.id === cotizationDetail.id) {

          return formatReservationWithDestinations({
            ...cotizationDetail,
            reservations_aerolines: [
              ...aerolinePrices.toAdd,
              ...aerolinePrices.toUpdate,
            ],
            reservations_hotels: [
              ...hotelPrices.toAdd,
              ...hotelPrices.toUpdate,
            ],
          });
        }
        return e;
      });
    });



    builder.addCase(
      createReservationThunk.fulfilled,
      (state, action) => {
        return;
        // const reservationFormatted = formatReservationWithDestinations(
        //  action.payload
        // );
        // state.reservations = [...state.reservations, reservationFormatted];
      }
    );

    builder.addCase(
      createReservationThunk.rejected,
      (state, action) => {
        state.status = "failed";
        state.error = action.error;
      }
    );


    builder.addCase(
      editReservationStatus.fulfilled,
      (state, action) => {
        const { id, status } = action.payload;
        state.reservations = state.reservations.map(reservation => {
          if (reservation.id === id)
            return {
              ...reservation,
              cotizationDetail: {
                ...reservation.cotizationDetail,
                status: status
              }
            }

          else return reservation
        })
      }
    );


  },
});

export const reservationsSelector = (state) => state.reservation.reservations;
export const reservationsOrdered = createDraftSafeSelector(
  reservationsSelector,
  (state) => {
    const copy = [...state];
    // Sort by updated_at desc (most recently modified first)
    // Fall back to created_at if updated_at is missing
    return copy.sort((a, b) => {
      const dateA = a.updated_at || a.cotizationDetail?.updated_at || a.created_at || '';
      const dateB = b.updated_at || b.cotizationDetail?.updated_at || b.created_at || '';
      return dateB.localeCompare(dateA);
    });
  }
);


export const reservationFoundSelector = (id) =>
  createDraftSafeSelector(reservationsSelector, (state) =>
    state.find((e) => e.id === id)
  );

export const { addReservation, resetReservationStatus } = reservationSlice.actions;

export default reservationSlice.reducer;
